/**
 * Viewport — responsive scaling to fill browser window.
 * Canvas width is dynamic (1920-2400) matching device aspect ratio,
 * so wider devices get zero letterboxing. Height stays 1080.
 * CSS transform is reserved for screen shake only — this prevents layout overflow
 * on mobile viewports (transform: scale() doesn't shrink the layout box).
 */

import { WORLD } from './constants';

let canvasEl: HTMLCanvasElement;
let currentScale = 1;
let shakeOffsetX = 0;
let shakeOffsetY = 0;
let lastShakeOffsetX = 0;
let lastShakeOffsetY = 0;

function applyShake(): void {
  if (shakeOffsetX !== 0 || shakeOffsetY !== 0) {
    canvasEl.style.transform = `translate(${shakeOffsetX}px, ${shakeOffsetY}px)`;
  } else {
    canvasEl.style.transform = '';
  }
}

function updateViewport(): void {
  const windowW = window.innerWidth;
  const windowH = window.innerHeight;

  currentScale = Math.min(windowW / WORLD.CANVAS_WIDTH, windowH / WORLD.CANVAS_HEIGHT);

  // CSS width/height for responsive sizing — affects layout box, no overflow.
  // Flexbox on body handles centering; container auto-sizes from canvas.
  canvasEl.style.width = `${WORLD.CANVAS_WIDTH * currentScale}px`;
  canvasEl.style.height = `${WORLD.CANVAS_HEIGHT * currentScale}px`;
  applyShake();
}

/** Set screen shake offset (screen pixels). Called by ScreenShake each frame. */
export function setScreenShakeOffset(x: number, y: number): void {
  if (x === lastShakeOffsetX && y === lastShakeOffsetY) return;
  shakeOffsetX = x;
  shakeOffsetY = y;
  lastShakeOffsetX = x;
  lastShakeOffsetY = y;
  applyShake();
}

export function initViewport(canvas: HTMLCanvasElement): void {
  canvasEl = canvas;
  window.addEventListener('resize', updateViewport);
  updateViewport();
}
